module.exports = __webpack_public_path__ + "img/guitar.72710bb7.webp";